import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Table,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import TableScrollbar from "react-table-scrollbar";
import moment from "moment";

import "./PurchaseOrder.scss";
import {
  getPurchaseOrderRowData,
  getPDFDownload,
  getMRCodeDetails,
  getPICodeDetails,
  POIacknowledge_open,
  ToggleEdit,
  handleBasePrice,
  orderDiscountPercentChangeValue,
  orderGrossValChangeValue,
  orderBasePriceChangeValue,
  orderTaxTypeSelecteChangeValue,
  orderTaxSelecteChangeValue,
  SubmitEditOrder,
} from "../../../store/PurchaseOrder/actions";
// import Defaultuser from "../../../assets/images/users/Default_User.png";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import { PurchaseOrderPdf, setPdfType } from "../../../store/Reports/actions";
import { MRDetailsModel_open } from "../../../store/PurchaseIndent/actions";
import { PIDetailsModel_open } from "../../../store/RequetForQuotation/actions";
import GetMRDetails from "../../GetMRDetails";
import GetPIDetails from "../../GetPIDetails";
import LoadingModel from "../../LoadingModel";
import ItemDetails from "../../ItemDetails";
import POIacknowledgeModel from "./POIacknowledge_model";
import Select from "react-select";

const taxTypeOptions = [
  { value: 1, label: "Inclusive" },
  { value: 2, label: "Exclusive" },
];
const taxPercentage = [
  {
    id: 3,
    name: "12%",
    tax: 12,
  },
  {
    id: 1,
    name: "18%",
    tax: 18,
  },
  {
    id: 5,
    name: "28%",
    tax: 28,
  },
  {
    id: 2,
    name: "5%",
    tax: 5,
  },
  {
    id: 4,
    name: "Exempted",
    tax: 0,
  },
];

function PdfViewer({ url }) {
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      try {
        let finalUrl = url;

        if (
          window.location.hostname === "localhost" &&
          url.startsWith("http://vendpin.dev.absol.in")
        ) {
          finalUrl = url.replace("http://vendpin.dev.absol.in", "");
        }

        const response = await fetch(finalUrl);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setPdfBlobUrl(blobUrl);
      } catch (err) {
        console.error("Failed to load PDF", err);
      }
    };
    fetchPdf();
  }, [url]);

  if (!pdfBlobUrl)
    return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

  return (
    <iframe
      src={pdfBlobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}
class PurchaseOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      item_details: {},
      selectedOrderLocation: null,
      showImageModal: false,
      fetchedMR: [],
    };

    this.tog_static = this.tog_static.bind(this);
  }

  caluclategross(e, item, type) {
    var qty;
    var price;
    var baseprice;
    var taxtype;
    var tax;
    var discountpercent;
    var discount;
    switch (type) {
      case 1:
        qty = e.target.value ? e.target.value : 0;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        this.props.itemQtyChangeValue({
          key: e.target.name,
          value: e.target.value ? e.target.value : 0,
          item,
        });
        break;
      case 2:
        qty = item.qty;
        price = item.price;
        discountpercent = parseFloat(
          e.target.value ? e.target.value : 0
        ).toFixed(2);
        baseprice = parseFloat(item.baseprice ? item.baseprice : 0).toFixed(2);
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        price = parseFloat(
          baseprice - baseprice * (discountpercent / 100)
        ).toFixed(2);
        discount = parseFloat(baseprice - price).toFixed(2);

        this.props.orderDiscountPercentChangeValue({
          key: e.target.name,
          value: parseFloat(e.target.value ? e.target.value : 0),
          price,
          discount,
          item,
        });

        break;
      case 3:
        qty = item.qty;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = parseFloat(e.value ? e.value : 0);
        tax = item.tax?.tax;
        this.props.orderTaxTypeSelecteChangeValue({
          key: "taxtype_name",
          label: e.label,
          key2: "taxtype_id",
          value: taxtype,
          item,
        });
        break;
      case 4:
        var taxData = taxPercentage.filter((i) => {
          return i.id === e.value;
        });

        qty = item.qty;
        price = item.price;
        baseprice = item.baseprice;
        discountpercent = item.discountpercent;
        taxtype = item.taxtype?.id;
        tax = taxData[0].tax;
        this.props.orderTaxSelecteChangeValue({
          id: taxData[0].id,
          name: taxData[0].name,
          tax: taxData[0].tax,
          item,
        });
        break;
      case 5:
        qty = item.qty;
        price = parseInt(item.price);
        baseprice = parseFloat(e.target.value ? e.target.value : 0);
        discountpercent = parseInt(item.discountpercent);
        taxtype = item.taxtype?.id;
        tax = item.tax?.tax;
        price = baseprice - baseprice * (discountpercent / 100);
        discount = parseFloat(baseprice - price).toFixed(2);
        this.props.orderBasePriceChangeValue({
          key: e.target.name,
          value: e.target.value ? e.target.value : 0,
          price,
          discount,
          // discountpercent,
          item,
        });
        break;
      default:
        break;
    }

    var gross = price * parseFloat(qty).toFixed(3);
    var taxamount = 0;
    if (taxtype === 1) {
      var basicValue = gross / ((100 + tax) / 100);
      taxamount = (basicValue / 100) * tax;
      var net = parseFloat(taxamount + basicValue).toFixed(3);
    } else {
      taxamount = (gross * tax) / 100;
      net = parseFloat(parseFloat(gross) + parseFloat(taxamount)).toFixed(3);
    }

    this.props.orderGrossValChangeValue(
      parseFloat(taxamount).toFixed(3),
      net,
      item
    );
  }

  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));
    this.props.getMRCodeDetails(item.id);
    this.props.getPICodeDetails(item.id, item.qitem);
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  componentDidMount() {
    if (this.props.match.params.id > 0) {
      this.props.getPurchaseOrderRowData(this.props.match.params.id);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.PORowData !== this.props.PORowData &&
      this.props.PORowData?.poitems
    ) {
      this.props.PORowData.poitems.forEach((item) => {
        if (!this.state.fetchedMR.includes(item.id)) {
          this.props.getMRCodeDetails(item.id);
          this.setState((prev) => ({
            fetchedMR: [...prev.fetchedMR, item.id],
          }));
        }
      });
    }
  }
  getPDF(Poid, type) {
    setPdfType(type);
    this.props.PurchaseOrderPdf(true, type);
    this.props.history.push("/poreportdoc/" + Poid);
  }

  getDetailedPOPDF(Poid, type, otherId) {
    this.props.PurchaseOrderPdf(true, type);
    // this.props.history.push("/podetailedreportdoc/" + Poid);
    this.props.history.push(`/podetailedreportdoc/${Poid}?otherId=${otherId}`);
  }

  submitPOItem(rowdata, poItemId) {
    this.props.SubmitEditOrder(rowdata, rowdata?.id, poItemId);
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
            <AvForm className="needs-validation">
              <Row>
                <Col md={12} className="p-1 W-100">
                  <Card className="p-0 ">
                    <CardHeader className="bg-transparent border-bottom ">
                      <div className="float-right ml-2">
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light mx-2 "
                          onClick={() =>
                            this.getDetailedPOPDF(
                              this.props.PORowData.id,
                              "detail",
                              this.props.PORowData?.vendor?.id
                            )
                          }
                        >
                          Download Detail Print
                        </Button>
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light mx-2 "
                          onClick={() =>
                            this.getPDF(this.props.PORowData.id, "internal")
                          }
                        >
                          Download Lalitha Print
                        </Button>
                        {/* <Button
													type="submit"
													color="primary"
													className="waves-effect waves-light "
													onClick={() =>
														this.getPDF(
															this.props.PORowData
																.id,
															"external"
														)
													}>
													Download Supplier's Print
												</Button> */}

                        {this.props.PORowData?.printapproval_status == 2 && (
                          <Button
                            type="submit"
                            color="primary"
                            className="waves-effect waves-light "
                            onClick={() =>
                              this.getPDF(this.props.PORowData.id, "external")
                            }
                          >
                            Download Supplier's Print
                          </Button>
                        )}
                      </div>
                      <Link
                        to="/PurchaseOrderDashboard"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>
                      <h5 className="card-title-18 pt-2 d-inline-block">
                        PurchaseOrder ({this.props.PORowData?.code})
                      </h5>
                    </CardHeader>
                    <CardBody className="p-2 ">
                      <Card className="p-1 m-0 ">
                        <CardBody className="pt-1 pb-1">
                          <Row className="p-0">
                            <Col md={12} className="p-1 m-0">
                              <div className="Indent-Request-panel-content">
                                <div className="list-column">
                                  <Row>
                                    <Col md={6}>
                                      <ul className="list-style-two p-0">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Vendor Name:
                                          </span>
                                          <span className="dtl">
                                            {this.props.PORowData?.vendor?.name}
                                          </span>
                                          {/* <span className="dtl">
                                            <ul className="user-column p-0">
                                              <li className="clearfix p-0 m-0">
                                                <span className="img">
                                                  <img
                                                    className="img-fluid p-0"
                                                    src={
                                                      this.props.PORowData
                                                        .vendor?.image == null
                                                        ? Defaultuser
                                                        : this.props.PORowData
                                                            .vendor?.image
                                                    }
                                                    alt="user"
                                                  />
                                                </span>
                                                <span className="userttl">
                                                  {
                                                    this.props.PORowData.vendor
                                                      ?.name
                                                  }
                                                </span>
                                              </li>
                                            </ul>
                                          </span> */}
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Vendor Location:
                                          </span>
                                          <span className="dtl">
                                            {this.props.PORowData?.vendor?.city}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Gross Value:
                                          </span>
                                          <span className="dtl">
                                            &#8377;{" "}
                                            {this.props.PORowData?.total}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">Reason:</span>
                                          <span className="dtl">
                                            {this.props.PORowData?.description}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Transport By:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.PORowData
                                                ?.transport_by_name
                                            }
                                          </span>
                                        </li>
                                      </ul>
                                    </Col>
                                    <Col md={6}>
                                      <ul className="list-style-two p-0">
                                        <li className="clearfix">
                                          <span className="ttl">RFQ No:</span>
                                          <span className="dtl">
                                            {
                                              this.props.PORowData
                                                ?.requestforquotation_code
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">RFQ Date:</span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.PORowData
                                                ?.requestforquotation_date
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            PO Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.PORowData?.location
                                                ?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">PO Type:</span>
                                          <span className="dtl">
                                            {
                                              this.props.PORowData
                                                ?.purchase_type_name
                                            }
                                          </span>
                                        </li>
                                      </ul>
                                    </Col>
                                  </Row>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>

                      <Row>
                        <Col
                          md={this.state.showImageModal ? 8 : 12}
                          xl={this.state.showImageModal ? 8 : 12}
                          className="m-1"
                        >
                          <Card className="pt-1">
                            <CardBody className="p-0">
                              <div className="table-responsive m-1">
                                <TableScrollbar height="400px">
                                  <Table className="mb-0 p-1 table-centered">
                                    <thead className="bg-light ">
                                      <tr>
                                        <th className="nowrap text-center">
                                          S.No
                                        </th>
                                        <th className="nowrap text-center">
                                          MR Details
                                        </th>
                                        <th className="nowrap text-center">
                                          PI Details
                                        </th>
                                        <th className="nowrap text-center">
                                          Item Images
                                        </th>
                                        <th
                                          style={{
                                            width: "320px",
                                            minWidth: "220px",
                                          }}
                                        >
                                          Item Name
                                        </th>
                                        {/* <th
                                          style={{
                                            width: "320px",
                                            minWidth: "220px",
                                          }}
                                        >
                                          Qualities
                                        </th> */}
                                        <th
                                          style={{
                                            width: "320px",
                                            minWidth: "220px",
                                          }}
                                        >
                                          Order Location
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Quantity
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Item Base Price
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Item Discount(%)
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Item Price <br />
                                          (Discount)
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Tax Type(%)
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Tax Amount
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Tax Percentage
                                        </th>
                                        <th className="nowrap text-center table_head">
                                          Gross Value
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.props.PORowData?.poitems?.map(
                                        (item, key) => (
                                          <React.Fragment key={key}>
                                            <tr key={key}>
                                              <td className="nowrap text-center">
                                                {key + 1}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item?.mrdata?.mrcodes ? (
                                                  <>
                                                    {item?.mrdata?.mrcodes
                                                      ?.length === 0 ? (
                                                      <>Not found</>
                                                    ) : (
                                                      <>
                                                        <Link
                                                          to="#"
                                                          onClick={() => {
                                                            this.props.MRDetailsModel_open(
                                                              item.mrdata
                                                                .mrcodes[0].id
                                                            );
                                                          }}
                                                          className="text-primary mr-1"
                                                        >
                                                          <u>
                                                            {
                                                              item.mrdata
                                                                .mrcodes[0].code
                                                            }
                                                          </u>
                                                        </Link>
                                                      </>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    <Link
                                                      to="#"
                                                      onClick={() => {
                                                        this.props.getMRCodeDetails(
                                                          item.id
                                                        );
                                                      }}
                                                      className="text-primary mr-1"
                                                    >
                                                      <u>View</u>
                                                    </Link>
                                                  </>
                                                )}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item?.pidata?.picodes ? (
                                                  <>
                                                    {item?.pidata?.picodes
                                                      .length === 0 ? (
                                                      <>Not found</>
                                                    ) : (
                                                      <>
                                                        <span
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() => {
                                                            this.props.PIDetailsModel_open(
                                                              item.pidata
                                                                .picodes[0].id
                                                            );
                                                          }}
                                                          className="text-primary mr-1"
                                                        >
                                                          <u>
                                                            {
                                                              item.pidata
                                                                .picodes[0].code
                                                            }
                                                          </u>
                                                        </span>
                                                      </>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => {
                                                        this.props.getPICodeDetails(
                                                          item.id,
                                                          item.qitem
                                                        );
                                                      }}
                                                      className="text-primary mr-1"
                                                    >
                                                      <u>View</u>
                                                    </span>
                                                  </>
                                                )}
                                              </td>
                                              <td className="nowrap text-center">
                                                <div className="product-detail text-center">
                                                  <img
                                                    src={
                                                      item?.product?.image ==
                                                      null
                                                        ? DefaultImg
                                                        : item?.product?.image
                                                    }
                                                    alt="product-img"
                                                    title="product-img"
                                                    className="product-img  img-fluid mx-auto tab-img rounded"
                                                    style={{
                                                      height: "100px",
                                                      width: "150px",
                                                    }}
                                                  />
                                                </div>
                                              </td>
                                              <td>
                                                <h5 className="font-size-14">
                                                  <Link
                                                    to="#"
                                                    onClick={() =>
                                                      this.tog_static(item)
                                                    }
                                                    className="text-dark"
                                                  >
                                                    {item.product.name}
                                                  </Link>
                                                  {item.poi_acknowledges
                                                    .length === 0 && (
                                                    <Link
                                                      to="#"
                                                      onClick={() =>
                                                        this.props.POIacknowledge_open(
                                                          {
                                                            POItem_Id: item.id,

                                                            PO_ID:
                                                              this.props
                                                                .PORowData.id,
                                                          }
                                                        )
                                                      }
                                                      className="text-danger"
                                                    >
                                                      <i className="text-danger ml-2 ri-pencil-line"></i>
                                                    </Link>
                                                  )}
                                                </h5>
                                                <p className="mb-0">
                                                  <b>Make :</b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.make}
                                                  </span>
                                                </p>
                                                <p className="mb-0">
                                                  <b>Description :</b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.description}
                                                  </span>
                                                </p>
                                                <p className="mb-0">
                                                  <b>Item Info :</b>{" "}
                                                  <span className="font-weight-medium">
                                                    {item.item_info}
                                                  </span>
                                                </p>
                                                {item.poi_acknowledges
                                                  .length !== 0 && (
                                                  <>
                                                    <p className="mb-0">
                                                      <b className="text-danger">
                                                        Acknowledge :
                                                      </b>
                                                      <span className="font-weight-medium">
                                                        {
                                                          item
                                                            .poi_acknowledges[0]
                                                            .description
                                                        }
                                                      </span>
                                                    </p>
                                                    <p className="mb-0">
                                                      <b className="text-danger">
                                                        Acknowledge By :
                                                      </b>
                                                      <span className="font-weight-medium">
                                                        {
                                                          item
                                                            .poi_acknowledges[0]
                                                            .createdby.fullname
                                                        }
                                                        (
                                                        {
                                                          item
                                                            .poi_acknowledges[0]
                                                            .createdby.username
                                                        }
                                                        )
                                                      </span>
                                                    </p>
                                                  </>
                                                )}
                                              </td>
                                              {/* <td className="nowrap text-center">
                                              {item.qualities?.length > 0
                                                ? item.qualities
                                                    .map((q) => q.name)
                                                    .join(", ")
                                                : "-"}
                                            </td> */}
                                              <td className="nowrap text-center">
                                                {item?.mrdata?.mrcodes?.[0]
                                                  ?.orderlocation?.name || "-"}
                                                {item?.mrdata?.mrcodes?.[0]
                                                  ?.orderlocation?.image && (
                                                  <Button
                                                    color="info"
                                                    size="sm"
                                                    className="ml-2"
                                                    disabled={
                                                      !item?.mrdata
                                                        ?.mrcodes?.[0]
                                                        ?.orderlocation?.image
                                                    }
                                                    onClick={() => {
                                                      this.setState({
                                                        showImageModal: true,
                                                        selectedOrderLocation:
                                                          item?.mrdata
                                                            ?.mrcodes?.[0]
                                                            ?.orderlocation ||
                                                          null,
                                                      });
                                                    }}
                                                  >
                                                    View
                                                  </Button>
                                                )}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.qty}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.baseprice}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.discountpercent}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.price} <br />
                                                <sup>( {item.discount} )</sup>
                                              </td>
                                              <td className="nowrap text-center">
                                                {`${item.taxtype_name} ${item.tax.name}`}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.taxamount}
                                              </td>
                                              <td className="nowrap text-center">
                                                {item.tax?.tax}
                                              </td>

                                              <td className="nowrap text-center">
                                                &#8377; {item.gross}
                                              </td>
                                            </tr>

                                            <tr>
                                              <td colSpan="8" className="p-2">
                                                <b>Qualities:</b>{" "}
                                                <span className="font-weight-medium">
                                                  {item.qualities?.length > 0
                                                    ? item.qualities
                                                        .map((q) => q.name)
                                                        .join(", ")
                                                    : "-"}
                                                </span>
                                              </td>
                                            </tr>
                                          </React.Fragment>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </TableScrollbar>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>

                        {this.state.showImageModal &&
                          this.state.selectedOrderLocation?.image && (
                            <Col md={12} xl={3}>
                              <Card className="p-1">
                                <CardHeader>
                                  <h5>
                                    Order Location Document:{" "}
                                    {this.state.selectedOrderLocation.name}
                                  </h5>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() =>
                                      this.setState({
                                        showImageModal: false,
                                      })
                                    }
                                  >
                                    Close
                                  </Button>
                                </CardHeader>
                                <CardBody className="p-0">
                                  {this.state.selectedOrderLocation?.image ? (
                                    (() => {
                                      const rawUrl =
                                        this.state.selectedOrderLocation.image;
                                      const cleanUrl = rawUrl.trim();
                                      const isPdf = /\.pdf(\?.*)?$/i.test(
                                        cleanUrl
                                      );

                                      return isPdf ? (
                                        <PdfViewer url={cleanUrl} />
                                      ) : (
                                        <img
                                          src={cleanUrl}
                                          alt="Order Location"
                                          style={{
                                            maxWidth: "100%",
                                            height: "auto",
                                          }}
                                        />
                                      );
                                    })()
                                  ) : (
                                    <p style={{ padding: 10 }}>
                                      No document available
                                    </p>
                                  )}
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                      </Row>

                      {/* <CardFooter className="bg-transparent p-1">
                        <div className="float-right">
                          <Button
                            type="Submit"
                            color="primary"
                            className="waves-effect waves-light mr-2"
                            // href="/quotationdashboard"
                          >
                            Back
                          </Button>
                         
                        </div>
                      </CardFooter> */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>

            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="POLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
            <GetPIDetails />
            <GetMRDetails />
            {this.props.POIacknowledgeData && <POIacknowledgeModel />}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const { PORowData, loading, POIacknowledgeData } = state.PurchaseOrder;
  return {
    PORowData,
    loading,
    POIacknowledgeData,
    userAccessList: state.Mini.userAccessList,
  };
};

export default connect(mapStatetoProps, {
  getPurchaseOrderRowData,
  getPDFDownload,
  PurchaseOrderPdf,
  getMRCodeDetails,
  MRDetailsModel_open,
  PIDetailsModel_open,
  getPICodeDetails,
  POIacknowledge_open,
  ToggleEdit,
  handleBasePrice,
  orderDiscountPercentChangeValue,
  orderGrossValChangeValue,
  orderBasePriceChangeValue,
  orderTaxTypeSelecteChangeValue,
  orderTaxSelecteChangeValue,
  SubmitEditOrder,
})(PurchaseOrder);
